<template>
  <modal>
    <template slot="header">
      <h3>{{messageText}}</h3>
    </template>
    <template slot="footer">
      <base-button @click="onClickCancel">{{cancelText}}</base-button>
      <base-button danger @click="onClickConfirm">{{confirmText}}</base-button>
    </template>
  </modal>
</template>

<script>
export default {
  name: 'base-dialog',

  props: {
    messageText: {
      type: String,
      default: 'Are you sure?',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'OK',
    },
  },

  methods: {
    onClickCancel() {
      this.$emit('cancel');
    },

    onClickConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>
